import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import { getDateOfBirthInfo as getDateOfBirthInfoApi } from "../../helpers/ServiceHelpers/backend_helper";

export const getDateOfBirthInfo = createAsyncThunk(
  "userInfo/getDateOfBirthInfo",
  async (id: number) => {
    try {
      const response = getDateOfBirthInfoApi(id);
      return response;
    } catch (error) {
      return error;
    }
  }
);
